import { escapeRegExp } from 'lodash';
import Highlighter from 'react-highlight-words';
import styled from 'styled-components';
import { ModelEntitySearchResponseItem } from '../../../../../../../../common/model/search/types';
import { friendlyCountryName } from '../../../../../../../../common/model/texts/friendly-country-name';
import { uppercaseFirstLetter } from '../../../../../../../untidy/texts';
import { BouColor } from '../../../../../../generic/global/bou-colors';
import { sanitizeSearch } from '../../shared';

interface Props {
  item: ModelEntitySearchResponseItem;
}

const Root = styled.div`
  color: #888888;
  flex-basis: auto;
  flex-grow: 1000000;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export function CountryBlock(props: Props) {
  const { item } = props;
  if (!item.country) {
    return <Root />;
  }
  const country = friendlyCountryName(item.country);
  if (item.name.includes(country)) {
    return <Root />;
  }
  return (
    <Root>
      <Highlighter
        textToHighlight={`${uppercaseFirstLetter(country)}`}
        searchWords={item.query && item.query.length > 3 ? [escapeRegExp(item.query)] : []}
        sanitize={sanitizeSearch}
        highlightStyle={{ backgroundColor: BouColor.TOOL_TEXT_HIGHLIGHT_YELLOW }}
      />
    </Root>
  );
}
